import React, { useEffect, useState } from 'react';
export function Timer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: 59,
          seconds: 59,
          hours: prev.hours
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex gap-4 justify-center font-montserrat text-2xl md:text-4xl font-bold text-brand-green" data-id="element-197">
      <div className="flex flex-col items-center" data-id="element-198">
        <span data-id="element-199">{format(timeLeft.hours)}</span>
        <span className="text-xs uppercase text-gray-400" data-id="element-200">hs</span>
      </div>
      <span data-id="element-201">:</span>
      <div className="flex flex-col items-center" data-id="element-202">
        <span data-id="element-203">{format(timeLeft.minutes)}</span>
        <span className="text-xs uppercase text-gray-400" data-id="element-204">min</span>
      </div>
      <span data-id="element-205">:</span>
      <div className="flex flex-col items-center" data-id="element-206">
        <span data-id="element-207">{format(timeLeft.seconds)}</span>
        <span className="text-xs uppercase text-gray-400" data-id="element-208">seg</span>
      </div>
    </div>;
}